import React, { Component } from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner, Table } from "react-bootstrap";
import Crypt from '../lib/Crypt';
import swal from 'sweetalert';
import C from '../lib/Config';

export default class AdverseEffectDisPopup extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            chemoReportID: '',
            chemoReportValue: '',
            adverseEffectReportArr: [],
            chemoMedicineDosageListArr: [],
            chemoMedicineDosageId: '',
            chemoMedicineDosageValue: '',
            adverseEffectDiscontinueId : 0
        }; 
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        this.getAllAdverseEffectMaster();  
    }
    handleChange(event){
        if(event.target.name === 'adverseEffectChemo'){
            this.setState({chemoMedicineDosageId: event.target.value});
            this.setState({chemoMedicineDosageValue: event.target.options[event.target.selectedIndex].text});
        }
        if(event.target.name === 'adverseEffectReport'){
            this.setState({chemoReportID: event.target.value});
            this.setState({chemoReportValue: event.target.options[event.target.selectedIndex].text});
        } 
    }
    // validateAdverseEff(){
    //     let formIsValid = true;
    //     let errors = {};
    //     if (this.state.adverseEffectChemo === "" || this.state.adverseEffectChemo === null) {
    //         errors["adverseEffectChemo"] = "Please enter first name";
    //         formIsValid = false;
    //     }
    //     if (this.state.adverseEffectReport === "" || this.state.adverseEffectReport === null) {
    //         errors["adverseEffectReport"] = "Please select schedule for doctor visit";
    //         formIsValid = false;
    //     } 
    //     this.setState({protocol: errors });
    //     return formIsValid;
    // }
    getAllAdverseEffectMaster() {
        fetch(C.getUrl() + '/adverseEffectMaster/getAllAdverseEffectMaster')
        .then(res => res.json())
        .then(res => {
            if (!res || !res.message) return;
            let resObj = JSON.parse(res.message);
            if (!Array.isArray(resObj)) return;
            var arr = [];
            resObj.forEach(function (d) {
                arr.push({ id: d.selectionId, name: d.selectionValue });
            });
            this.setState({ adverseEffectReportArr: arr });
        })
        .catch(err => {
            console.error("Error fetching adverse effects: " + err);
        });
    }
    saveAdverseEffect(event){
        let data = { 
            reportID: this.state.chemoReportID,
            reportValues: this.state.chemoReportValue,
            chemoMedicineDosageID: this.state.chemoMedicineDosageId,
            chemoMedicineDosageValue: this.state.chemoMedicineDosageValue,
            adverseEffectDiscontinueId: this.state.adverseEffectDiscontinueId
        }
        this.props.saveAdvEffDiscontinue(data); 
    }
    getAdverseEffectDetail(chemoDoseageList) {
        this.setState({ chemoMedicineDosageListArr: chemoDoseageList });  
    }
    render() {
        const { showAdverseEffectDisPopup, closeModal} = this.props;
        const closePreviewModal = () => {
            closeModal();
        }
        const { adverseEffectReportArr, chemoMedicineDosageListArr } = this.state;
        return (
            <div>
                <Modal id="report" show={showAdverseEffectDisPopup} centered animation={true} scrollable={true} size="md">
                    <Modal.Header closeButton onClick={() => closePreviewModal()}>
                        <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">Adverse Event Discontinue</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container fluid>
                            <Row>
                                <Col lg="12">
                                    <Form.Group>
                                        <Form.Label>Adverse Event</Form.Label>
                                        <Form.Control as="select" id="" name='adverseEffectReport' value={this.state.chemoReportID} onChange={this.handleChange}>
                                            <option value="DEFAULT">- Select Adverse Event -</option>
                                            {
                                                adverseEffectReportArr.map((item, i) => {
                                                        return (
                                                            <option key={item.id} value={item.id}>{`${item.name}`}</option>
                                                        );
                                                    })
                                                }
                                        </Form.Control>
                                    </Form.Group>
                                    {/* <div className="invalid-feedback">{this.state.protocol["chemoMedicine"]}</div> */}
                                </Col>
                                <Col lg='12'>
                                    <Form.Group>
                                        <Form.Label>Chemo Medicine</Form.Label>
                                        <Form.Control as="select" id="" name='adverseEffectChemo' value={this.state.chemoMedicineDosageId} onChange={this.handleChange}>
                                            <option value="DEFAULT">- Select Chemo Medicine -</option> 
                                                { 
                                                    chemoMedicineDosageListArr.map((item, i) => {
                                                        return (
                                                            <option key={item.chemoMedicineId} value={item.chemoMedicineId}>{`${item.chemoMedicineName}`}</option>
                                                        );
                                                    })
                                                }
                                        </Form.Control>
                                        {/* <div className="invalid-feedback">{this.state.protocol["dosageMethod"]}</div> */}
                                    </Form.Group>
                                </Col> 
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer className='text-center'>
                    <Button className="btn btn-secondary" onClick={this.saveAdverseEffect.bind(this)}>
                            {this.state.saveLoader && (
                                <Spinner className='mr-2' animation='border' size='1.5rem' />
                            )}
                            Add 
                        </Button>
                        <Button variant="outline-danger" onClick={() => closePreviewModal()}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}